import type { TrackingEvent, TrackingPayload } from '~/types/tracking'

const useExperimentsEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackTriggerExperiment: (payload: {
    experiment_name: string
    experiment_variant: string
  }) => track('experiment_triggered', payload),
})

export default useExperimentsEvents
